export const navigateToSample = async () => {
  await navigateTo('https://weathernews.jp/smart/wnt_sample/simple.html?menu=golf_wind&abtest=a', { external: true })
}
